import { useState } from "react";
import axios from "axios";
import { FormCheckbox, PartnerFormInput, Success } from "components/modules";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { CenterLoader } from "components/widgets";
import { toast } from "react-toastify";
import { IndividualFormProps } from "types";

const IndividualForm = () => {
  const [openModal, setOpenModal] = useState<true | null>(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const individualFormValidation = Yup.object({
    first_name: Yup.string().required("Please enter your First Name").min(2, "Invalid First Name"),
    last_name: Yup.string().required("Please enter your Last Name").min(2, "Invalid Last Name"),
    email: Yup.string().required("Please enter your Email Address").email("Invalid email address")
  });

  const formikInitialValues = {
    logo: null,
    first_name: "",
    last_name: "",
    email: "",
    website_url: "",
    finance: false,
    awareness: false,
    legislative: false,
    socialMedia: false,
    professional: false,
    others: false
  };

  const handleSubmit = async (values: IndividualFormProps) => {
    setIsLoading(true);
    setIsSuccess(false);

    try {
      const res = await axios.post("/api/individualform", values);

      if (res.status >= 200 && res.status < 300) {
        setIsSuccess(true);
      } else {
        setErrorMessage(`Request failed with status code: ${res.status}`);
        setIsSuccess(false);
        toast.error(errorMessage);
      }
    } catch (err: any) {
      setErrorMessage(err.message);
      setIsSuccess(false);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-green rounded-md md:p-8 p-3 mt-12">
      {isSuccess && <Success response="" />}
      {!isSuccess && (
        <>
          <p className="text-white md:text-4xl text-2xl font-bold text-center pb-12">
            Partner Registration
          </p>
          <Formik
            initialValues={formikInitialValues}
            validationSchema={individualFormValidation}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ isSubmitting }) => (
              <Form encType="multipart/form-data">
                {isLoading ? (
                  <div className="text-center mt-8">
                    <CenterLoader />
                  </div>
                ) : (
                  <>
                    <div className="grid grid-cols-1 md:gap-8 gap-4">
                      <div className="grid md:grid-cols-2 grid-cols-1 md:gap-8 gap-4">
                        <PartnerFormInput nameAndId="first_name" label="First Name" />
                        <PartnerFormInput nameAndId="last_name" label="Last Name" />
                      </div>
                      <PartnerFormInput nameAndId="email" label="Email" />
                      <PartnerFormInput nameAndId="website_url" label="Website URL" />
                    </div>

                    <p className="font-bold md:text-2xl text-base text-white mt-8">
                      Why do you want to Partner with Us?
                    </p>

                    <div className="grid md:grid-cols-2 grid-cols-1 md:gap-8 gap-4 mt-4">
                      <FormCheckbox type="checkbox" nameAndId="finance" label="Finance and Aid" />
                      <FormCheckbox
                        type="checkbox"
                        nameAndId="awareness"
                        label="Awareness Campaign"
                      />
                      <FormCheckbox
                        type="checkbox"
                        nameAndId="legislative"
                        label="Legislative Laws and Policy"
                      />
                      <FormCheckbox
                        type="checkbox"
                        nameAndId="socialMedia"
                        label="Social Media Influence"
                      />
                      <FormCheckbox
                        type="checkbox"
                        nameAndId="professional"
                        label="Professional Partnership"
                      />
                      <FormCheckbox type="checkbox" nameAndId="others" label="Others" />
                    </div>

                    <div className="mt-16 mb-8 flex items-center justify-center">
                      <button
                        // type="submit"
                        className="text-white text-2xl bg-orange hover:bg-[#FFAC2A] py-3 px-4 md:w-72 w-full md:h-16 h-12 flex items-center justify-center rounded-md"
                        disabled={isSubmitting}
                        onClick={() => setOpenModal(true)}
                      >
                        Submit
                      </button>
                    </div>
                  </>
                )}
              </Form>
            )}
          </Formik>
        </>
      )}
      {openModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-5">
          <div className="p-2 flex flex-col gap-4 items-center justify-center h-[362px] w-[334px] bg-white rounded-lg">
            <p className="text-black text-base font-bold">Are you sure you want to submit?</p>
            <div className="flex md:flex-row flex-col gap-2 w-full p-2">
              <button
                className="p-2 border-2 border-orange bg-white text-orange rounded-md w-full"
                onClick={() => {
                  setOpenModal(null);
                }}
              >
                Cancel
              </button>

              <button
                className="p-2 bg-orange text-white rounded-md border-2 border-orange w-full"
                type="submit"
                onClick={() => {
                  setOpenModal(null);
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IndividualForm;
